import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Archive } from 'lucide-react';

/**
 * List of archived applicants with Restore + permanent Delete actions.
 *
 * Props:
 *   users: array of archived user objects (uid, email, profile.{firstName,lastName,phone,study})
 *   onUnarchive(uid): callback to restore a user
 *   onDelete(uid, displayName): callback to permanently delete a user
 */
export const ArchivedUsersList = ({ users = [], onUnarchive, onDelete }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-bold font-outfit">Archivierte Bewerber</h2>
        <p className="text-slate-600 text-sm">{users.length} archivierte Bewerber</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {users.map((applicant) => {
          const fullName = `${applicant.profile?.firstName || ''} ${applicant.profile?.lastName || ''}`.trim() || applicant.email;
          return (
            <Card
              key={applicant.uid}
              className="border-slate-100 shadow-sm rounded-2xl bg-slate-50"
              data-testid={`archived-user-card-${applicant.uid}`}
            >
              <CardHeader>
                <CardTitle className="text-lg font-outfit">
                  {applicant.profile?.firstName} {applicant.profile?.lastName}
                </CardTitle>
                <p className="text-sm text-slate-600">{applicant.profile?.study}</p>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 mb-2">{applicant.email}</p>
                <p className="text-sm text-slate-600 mb-3">{applicant.profile?.phone}</p>
                <Badge className="mb-4">Archiviert</Badge>
                <div className="flex gap-2">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onUnarchive(applicant.uid)}
                    data-testid={`unarchive-user-${applicant.uid}`}
                    className="flex-1"
                  >
                    Wiederherstellen
                  </Button>
                  <Button
                    size="sm"
                    variant="destructive"
                    onClick={() => onDelete(applicant.uid, fullName)}
                    data-testid={`delete-user-${applicant.uid}`}
                  >
                    Löschen
                  </Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {users.length === 0 && (
        <div className="text-center py-12">
          <Archive className="w-16 h-16 text-slate-300 mx-auto mb-4" />
          <p className="text-slate-600">Keine archivierten Bewerber</p>
        </div>
      )}
    </div>
  );
};
